// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iRYV","content":"styles_content__3SfuL"};